export default "__VITE_ASSET__D4m3sp_4__"